import $ from "jquery";
import Vue from "vue";
import * as ers from "../../../errorsmessages/errors";
import * as suc from "../../../successmessages/success";
import * as rt from "../../../routes/routes";
import * as ses from "../../../configurations/session/sessioncomplete";
import baseurl from "../../../configurations/baseurl/baseurl";
import router from "../../../router/index";

export const actions = {
  newRequisition() {
    let requisitionDetails = {
      bond_id: $(".bond_id").val(),
      truck_id: $(".truck_id").val(),
      cargo_id: $(".cargo_id").val(),
      loading_date: $(".loading_date").val(),
      port_cfs: $(".port_cfs").val()
    };
    console.log(requisitionDetails);

    $(".creatingRequisition").hide(), $(".creatingRequisitionLoader").show();
    baseurl.post(rt.newRequisition, requisitionDetails).then(res => {
      $(".creatingRequisition").show();
      $(".creatingRequisitionLoader").hide();

      //checking response codes from backend api

      if (res.data.code === 200) {
        //success code
        suc.requisitionCreateSuccess();
        router.push("/managebonds");
      } else if (res.data.code === 402) {
        //validation code
        ers.validateErrors();
      } else if (res.data.code === 403) {
        //requistion exists
        ers.RequisitionExists();
      } else if (res.data.code === 404) {
        //error on adding data
        ers.errorCreatingRequisition();
      } else if (res.data.code === 405) {
        //no permission to create
        ers.noPermissionToCreate();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  },

  loadRequisitions({ commit }) {
    baseurl.get(rt.loadRequisitions).then(res => {
      $(".requisitionsLoader").hide();

      //checking response codes from backend api

      if (res.data.code === 200) {
        //success codes
        commit("STORE_REQUISITIONS", res.data.requisitions);
      } else if (res.data.code === 404) {
        //error on loading data
        ers.errorLoadingRequisition();
      } else if (res.data.code === 405) {
        //no permission to read
        commit("STORE_REQUISITIONS", []);
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  },
  loadTransporter({ commit }) {
    baseurl.get(rt.loadTransporter).then(res => {
      $(".transporterLoader").hide();

      //checking response codes from backend api

      if (res.data.code === 200) {
        //success code
        commit("STORE_TRANSPORTER", res.data.transporter);
      } else if (res.data.code === 404) {
        //error on loading data
        ers.errorLoadingTransporters();
      } else if (res.data.code === 405) {
        //no permission to read
        commit("STORE_TRANSPORTER", []);
        ers.noPermissionToRead();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  },
  loadTransportertrucks({ commit }) {
    let transporterDetails = {
      transporter_id: $(".transporter_id").val()
    };
    baseurl.post(rt.loadTransporttrucks, transporterDetails).then(res => {
      $(".transportertrucksLoader").hide();

      //checking response codes from backend api

      if (res.data.code === 200) {
        //success code
        commit("STORE_TRANSPORTER_TRUCKS", res.data.transportertrucks);
      } else if (res.data.code === 404) {
        //error on loading data
        ers.errorLoadingTruck();
      } else if (res.data.code === 405) {
        //no permission to read
        commit("STORE_TRANSPORTER_TRUCKS", []);
        ers.noPermissionToRead();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  },
  viewRequisition({ commit }, requisitionId) {
    commit("STORE_REQUISITION_UPDATE", requisitionId);
    router.push("/newbondtracking");
  },
  
  viewRequisitiontruck({ commit }, requisitionId) {
    commit("STORE_REQUISITION_UPDATE", requisitionId);
    router.push("/newtrucktracking");
  },
  viewContainerinterchange({ commit }, requisitionId) {
    commit("STORE_REQUISITION_UPDATE", requisitionId);
    router.push("/cotainerinterchange");
  }

};
export default actions;



// WEBPACK FOOTER //
// ./src/vuex/modules/requisitions/actions.js